import React from 'react';
import ReactDOM from 'react-dom'; 
import Cookies from 'universal-cookie';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/common/space.scss";
import Main from "./router";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import Wrapper from 'Languages/Wrapper/Wrapper';

// method to save the URL in cookies
const cookies = new Cookies();
cookies.set('refurl', window.location.href , { path: '/' });

ReactDOM.render(
  <React.StrictMode>
    <Wrapper>
    <Main />
    </Wrapper>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
